/* eslint-disable @typescript-eslint/no-unused-vars */
import { ReactElement } from 'react';
import { ApexOptions } from 'apexcharts';
import RawDataOverviewContainer from './OverviewContainer';
import ApexHeatMap from '../ApexHeatMap';
import { DeviceType } from '../../constants/telosair-interfaces';

type ApexHeatMapTrendsProps = {
  onZoom?: () => void;
  isZoomed?: boolean;
  onBackPress?: () => void;
  data: { name: string; data: { x: string; y: number | null }[] }[];
  sectionName: string;
  isDataLoading: boolean;
  yLabelWidth?: string;
  parameter: string;
  noData: boolean;
  resizing: boolean;
  yLabelFormat?: (label: string) => string;
  type: DeviceType;
};

/**
 * React component for WeeklyBoxTrendsTrends.
 * @param props - Properties of WeeklyBoxTrendsTrends component.
 * @returns - React component for WeeklyBoxTrendsTrends.
 */
export default function ApexHeatMapTrends(props: ApexHeatMapTrendsProps): ReactElement {
  const {
    onZoom,
    onBackPress,
    isZoomed,
    data,
    sectionName,
    isDataLoading,
    noData,
    parameter,
    yLabelWidth,
    yLabelFormat,
    resizing,
    type
  } = props;
  return (
    <RawDataOverviewContainer
      size={isZoomed ? 'full' : '2/4'}
      onZoom={onZoom}
      onBackPress={onBackPress}
      sectionName={sectionName}
      zoomed={isZoomed}
      noDataText={noData && 'Data unavailable'}
      loading={isDataLoading}
    >
      <ApexHeatMap
        isZoomed={isZoomed}
        data={data}
        parameter={parameter}
        resizing={resizing}
        isDataLoading={isDataLoading}
        type={type}
      />
    </RawDataOverviewContainer>
  );
}
